// import { useNavigate } from "react-router-dom";
// import useAuth from "./useAuth";
// import { ReactNode, useEffect, useState } from "react";
// import { EPlayerRole } from "cresus-common";
// import useSession from "./useSession";
// import { GameStateDTO, getDefaultGameStateDTO } from "cresus-common";
// import { deepCopy } from "cresus-common";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EPlayerRole } from "cresus-common";
import { useEffect } from "react";
import { useNavigateKeepSession } from "../tools/useNavigateKeepSession";
import useSessionContext from "../tools/useSessionContext";
import useAuth from "./useAuth";
// // Handles default navigation for the app
// // Done in a tricky way to avoid rerender contexts when navigating causing issues with the MediaContext
// function DefaultNavigation(props: IDefaultNavigationProps) {
//   const navigate = useNavigateKeepSession();
//   const { role } = useAuth();
//   const { sendRequest } = useSession();
//   console.log("DefaultNavigation RENDERING");
//   async function getGameState() {
//     console.log("getGameState CALL");
//     const result = await sendRequest("onConnectionOrReaload", {}).catch(
//       (error) => {
//         console.error("onConnectionOrReaload", error);
//       }
//     );
//     console.log("getGameState useEffect insideGameState", result);
//     if (result !== undefined) {
//       onceGameStateIsReady(result);
//     }
//   }
//   useEffect(() => {
//     getGameState(); // TODO this might cause an infinite loop
//   });
//   function onceGameStateIsReady(gameState: GameStateDTO) {
//     console.log("useEffect insideGameState", gameState);
//     if (gameState.sessionStarted) {
//       if (role === EPlayerRole.ANIMATOR) {
//         if (gameState.gameStarted) navigate("/AnimatorGamePage");
//         else if (gameState.projectSelectionOn)
//           navigate("/DistributionProjectPage");
//         else if (gameState.avatarSelectionOn) navigate("/TeamSelectionPage");
//         else navigate("/IntroductionRoomPage");
//       } else {
//         navigate("/ReconnectionPage");
//       }
//     } else {
//       if (role === EPlayerRole.ANIMATOR) {
//         navigate("/WaitingRoomPage");
//       } else {
//         navigate("/ChooseNamePage");
//       }
//     }
//   }
//   return <>{/* {props.children} */}</>;
// }
// export default DefaultNavigation;
export function DefaultNavigation(props) {
    const navigate = useNavigateKeepSession();
    const { role, isLogged } = useAuth();
    const { gameState } = useSessionContext(); // Use the context instead of manual fetch
    const { sendRequest } = useSessionContext();
    useEffect(() => {
        // Only navigate if the user is logged in and gameState is loaded
        if (!isLogged)
            return;
        function fetchGameStateAndNavigate() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    // 1. Fetch the REAL game state from the WebSocket server
                    const realGameState = yield sendRequest("onConnectionOrReaload", {});
                    // Safety check in case the server takes a moment or fails
                    if (!realGameState)
                        return;
                    // 2. Navigate based on the LIVE data, not the hardcoded default
                    if (realGameState.sessionStarted) {
                        if (role === EPlayerRole.ANIMATOR) {
                            if (realGameState.gameStarted) {
                                navigate("/AnimatorGamePage");
                            }
                            else if (realGameState.projectSelectionOn) {
                                navigate("/DistributionProjectPage");
                            }
                            else if (realGameState.avatarSelectionOn) {
                                navigate("/TeamSelectionPage");
                            }
                            else {
                                navigate("/IntroductionRoomPage");
                            }
                        }
                        else {
                            // Non-animator on a started session: try to rejoin the game
                            // silently using the stored player name (covers the browser
                            // Back-button case, where the player is still fully attached
                            // server-side) before falling back to the manual reconnection
                            // screen — so she is routed straight back into the game instead
                            // of being stranded on the player-selection page.
                            const storedName = sessionStorage.getItem("playerName");
                            let joinResult = undefined;
                            if (storedName) {
                                joinResult = yield sendRequest("joinAsPlayer", {
                                    player: { name: storedName },
                                }).catch(() => undefined);
                            }
                            if (joinResult) {
                                if (joinResult.gameStarted)
                                    navigate("/GameInProgressPage");
                                else if (joinResult.projectSelectionOn)
                                    navigate("/PlayerDistributionProjectPage");
                                else if (joinResult.avatarSelectionOn)
                                    navigate("/AvatarCompositionPage");
                                else
                                    navigate("/IntroductionPlayerPage");
                            }
                            else {
                                navigate("/ReconnectionPage");
                            }
                        }
                    }
                    else {
                        // Session not started
                        if (role === EPlayerRole.ANIMATOR) {
                            navigate("/WaitingRoomPage");
                        }
                        else {
                            navigate("/ChooseNamePage");
                        }
                    }
                }
                catch (error) {
                    console.error("Failed to fetch game state:", error);
                }
            });
        }
        fetchGameStateAndNavigate();
    }, [isLogged, role, navigate, sendRequest]);
    return null;
}
